(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[42215,52892],{

/***/ 58151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thriftyadvice/privacy-policy",
      function () {
        return __webpack_require__(90252);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PrivacyPolicyHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_legal_privacyPolicy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57079);
/* harmony import */ var _components_layouts_thriftyAdviceWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68787);
/* harmony import */ var _components_thriftyadvice_privacy_policy_legal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92239);
/* harmony import */ var _components_thriftyadvice_privacy_policy_legal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_thriftyadvice_privacy_policy_legal_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var __N_SSP = true;
function PrivacyPolicyHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_thriftyAdviceWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_legal_privacyPolicy__WEBPACK_IMPORTED_MODULE_1__["default"], {
            mainWrapperClassName: (_components_thriftyadvice_privacy_policy_legal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().legal)
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [57079,51132,49774,92888,40179], function() { return __webpack_exec__(58151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);